import styled from "styled-components";
import Colors from "../../../../themes/Colors";

const RefinateFiltersFormHolder = styled.div`

  @media only screen and (max-width: 768px) {
    padding: 8px;
  }

  .inputSelect {
    width: 100%;
    padding: 0 10px 0 10px;
  }

  .noWrap {
    /* flex-wrap: nowrap; */
    padding-bottom: 20px;
  }
  .filterButtonModal {
    width: 100%;
    padding: 0 10px 0 10x;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media only screen and (min-width: 900px) {
      justify-content: center;
    }
  }
  .filterButtonModal:hover {
    background-color: ${Colors.gray};
  }
  .filterButtonModal.ant-popover-open {
    background-color: ${Colors.gray};
  }
  .filterButtonModalDates {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .filterButtonModalDate {
    width: 100%;
  }
  .filterCurrency span {
    font-size: 11px !important;
  }

  /* ---- Table-view layout: each filter section is a rounded card ---- */
  /* Uniform 10px gap between every card (rows and full-width cards alike). */
  .filtersStack {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 10px;
  }
  /* Below 1200px the paired cards of a row stack: same gap between them. */
  .filtersStack > .ant-row-flex {
    row-gap: 10px;
  }
  .filterCard {
    background: ${Colors.snow};
    border: 1px solid ${Colors.border};
    border-radius: 16px;
    padding: 12px;
    height: 100%;
  }

  .filterCardTitle {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    font-weight: 500;
    color: ${Colors.textStrong};
    margin-bottom: 16px;
  }

  .filterFieldLabel {
    display: block;
    font-size: 12px;
    color: ${Colors.textMuted};
    margin-bottom: 4px;
  }

  .filterFieldGroup {
    margin-bottom: 16px;
  }
  .filterFieldGroup:last-child {
    margin-bottom: 0;
  }

  /* Ad format checkboxes stacked and left-aligned (Ant indents siblings with
     margin-left by default, which misaligns them in a vertical layout). */
  .adFormatGroup {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  .adFormatGroup .ant-checkbox-wrapper {
    margin-left: 0;
  }

  /* ---- Points of interest: toggleable pill chips ---- */
  .poiChips {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  .poiChip {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 6px 14px;
    border: 1px solid ${Colors.borderStrong};
    border-radius: 20px;
    background: ${Colors.snow};
    color: ${Colors.textSecondary};
    font-size: 13px;
    line-height: 1.2;
    cursor: pointer;
    transition: color 0.15s ease, border-color 0.15s ease,
      background-color 0.15s ease;
  }
  .poiChip .anticon {
    font-size: 12px;
  }
  .poiChip:hover {
    color: ${Colors.primaryAccent};
    border-color: ${Colors.primaryAccent};
  }
  .poiChip.selected {
    color: ${Colors.primaryAccent};
    border-color: ${Colors.primaryAccent};
    background: ${Colors.extraLightPrimary};
  }

  .footerActions {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    margin-top: 24px;
  }
`;

export default RefinateFiltersFormHolder;
